import { Reducer } from "redux";
import { CaseStudySearchItem, ICaseStudySearchPagedResponse } from "../business-objects/common";
import { CaseStudySearchActionTypes } from "./types";

// Type-safe initialState!
const initialState: ICaseStudyState = {
  searchResults: {crashes: [], vehicles: [], summary: null, totalResults: 0},
  loading: false,
  selectedRows: []
};

export interface ICaseStudyState {
  searchResults: ICaseStudySearchPagedResponse;
  loading: boolean;
  selectedRows: CaseStudySearchItem[];
}

const reducer: Reducer<ICaseStudyState> = (state = initialState, action) => {
  //console.log('action', action);
  switch (action.type) {
    case CaseStudySearchActionTypes.GET_CASE_STUDY_RESULTS: {
      return { ...state, searchResults: action.value };
    }case CaseStudySearchActionTypes.LOADING: {
      return { ...state, loading: action.value };
    }case CaseStudySearchActionTypes.SET_SELECTED_ROWS: {
      return { ...state, selectedRows: action.value };
    }
    
    
    default: {
      return state;
    }
  }
};

export default reducer;
